import Swal from "sweetalert2";
import ReactDOM from "react-dom";
import Loader from "../Components/Loader";
import { Fragment } from "react";

var url_json = require("../location.json");

if (window.location.origin.includes("localhost")) {
  url_json = url_json.local;
} else {
  url_json = url_json.production;
}

const Eetiquetas = {
  agregarEtiqueta: async (data) => {
    ReactDOM.render(
      <div className="loader_padre">
        <Loader />
      </div>,
      document.getElementById("loader_padre")
    );

    let url = url_json + "/etiqueta-blog";
    let body = {
      nombre: data.nombre,
    };
    let request = {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
    };

    let response = await fetch(url, request);
    let res = await response.json();

    ReactDOM.render(
      <Fragment></Fragment>,
      document.getElementById("loader_padre")
    );

    if (response.ok) {
      Swal.fire(
        "Inserción exitosa!",
        "Etiqueta agregada correctamente",
        "success"
      ).then(() => {
        window.location.reload();
      });
    } else {
      Swal.fire(
        "Error!",
        "No se pudo guardar la etiqueta, codigo: " + res.message,
        "error"
      );
    }
    return { success: response.ok, data: res.data, code: res.message };
  },
  obtenerEtiquetas: async () => {
    let url = url_json + "/etiqueta-blog";
    let request = {
      method: "GET",
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
    };

    let response = await fetch(url, request);
    let json = await response.json();
    return { success: response.ok, data: json.data, code: json.message };
  },
  obtenerEtiquetasIDs: async (ids) => {
    let url = url_json + "/etiqueta-blog/ids";
    let body = {
      ids,
    };

    let request = {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
    };

    let response = await fetch(url, request);
    let json = await response.json();
    return { success: response.ok, data: json.data, code: json.message };
  },
  obtenerUnaEtiqueta: async (id) => {
    let url = url_json + "/etiqueta-blog/" + id;
    let request = {
      method: "GET",
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
    };

    let response = await fetch(url, request);
    let json = await response.json();
    return { success: response.ok, data: json.data, code: json.message };
  },
  editarEtiqueta: async (data, id) => {
    Swal.fire({
      icon: "question",
      title: "¿Esta seguro que desea modificar la etiqueta?",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Si",
      denyButtonText: `No`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        ReactDOM.render(
          <div className="loader_padre">
            <Loader />
          </div>,
          document.getElementById("loader_padre")
        );

        let url = url_json + "/etiqueta-blog/" + id;

        let body = {
          nombre: data.nombre,
        };
        let request = {
          method: "PATCH",
          body: JSON.stringify(body),
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };

        let response = await fetch(url, request);
        let res = await response.json();

        ReactDOM.render(
          <Fragment></Fragment>,
          document.getElementById("loader_padre")
        );

        if (response.ok) {
          Swal.fire(
            "Modificación exitosa!",
            "Etiqueta modificada correctamente",
            "success"
          ).then(() => {
            window.location.reload();
          });
        } else {
          Swal.fire("Error!", "No se pudo modificar la etiqueta", "error").then(
            () => {
              window.location.reload();
            }
          );
        }
      } else if (result.isDenied) {
        Swal.fire("Modificación cancelada", "El campo quedo intacto", "succes");
      }
    });
  },
  eliminarEtiqueta: async (id) => {
    Swal.fire({
      icon: "question",
      title: "¿Esta seguro que desea eliminar la etiqueta?",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Si",
      denyButtonText: `No`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        ReactDOM.render(
          <div className="loader_padre">
            <Loader />
          </div>,
          document.getElementById("loader_padre")
        );

        let url = url_json + "/etiqueta-blog/delete/" + id;
        let request = {
          method: "PATCH",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };

        let response = await fetch(url, request);
        let res = await response.json();

        ReactDOM.render(
          <Fragment></Fragment>,
          document.getElementById("loader_padre")
        );

        if (response.ok) {
          Swal.fire(
            "Eliminación exitosa!",
            "Etiqueta eliminada correctamente",
            "success"
          ).then(() => {
            window.location.reload();
          });
        } else {
          Swal.fire("Error!", "No se pudo eliminar la etiqueta", "error");
        }
        return { success: response.ok, data: res.data };
      } else if (result.isDenied) {
        Swal.fire("Eliminación cancelada", "El campo quedo intacto", "succes");
      }
    });
  },
};

export default Eetiquetas;
